import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=3b6d69bb&scoped=true&"
import script from "./Rules.vue?vue&type=script&lang=ts&"
export * from "./Rules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6d69bb",
  null
  
)

export default component.exports